export const appState = $state({
  user: null,
  sidebarOpen: true,
  cookieConsent: null, // null = no choice (show banner), true = accepted, false = declined
})
